import src from "IMAGE";
export default { src, width: 107, height: 138, blurWidth: 0, blurHeight: 0};
